var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/calendar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 11C7.55228 11 8 10.5523 8 10C8 9.44771 7.55228 9 7 9C6.44772 9 6 9.44771 6 10C6 10.5523 6.44772 11 7 11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 10C13 10.5523 12.5523 11 12 11C11.4477 11 11 10.5523 11 10C11 9.44771 11.4477 9 12 9C12.5523 9 13 9.44771 13 10Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 11C17.5523 11 18 10.5523 18 10C18 9.44771 17.5523 9 17 9C16.4477 9 16 9.44771 16 10C16 10.5523 16.4477 11 17 11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 13.5C8 14.0523 7.55228 14.5 7 14.5C6.44772 14.5 6 14.0523 6 13.5C6 12.9477 6.44772 12.5 7 12.5C7.55228 12.5 8 12.9477 8 13.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14.5C12.5523 14.5 13 14.0523 13 13.5C13 12.9477 12.5523 12.5 12 12.5C11.4477 12.5 11 12.9477 11 13.5C11 14.0523 11.4477 14.5 12 14.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 13.5C18 14.0523 17.5523 14.5 17 14.5C16.4477 14.5 16 14.0523 16 13.5C16 12.9477 16.4477 12.5 17 12.5C17.5523 12.5 18 12.9477 18 13.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 18C7.55228 18 8 17.5523 8 17C8 16.4477 7.55228 16 7 16C6.44772 16 6 16.4477 6 17C6 17.5523 6.44772 18 7 18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16C12.5523 16 13 16.4477 13 17Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 18C17.5523 18 18 17.5523 18 17C18 16.4477 17.5523 16 17 16C16.4477 16 16 16.4477 16 17C16 17.5523 16.4477 18 17 18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75 3C7.75 2.58579 7.41421 2.25 7 2.25C6.58579 2.25 6.25 2.58579 6.25 3H6C3.79086 3 2 4.79086 2 7V18C2 20.2091 3.79086 22 6 22H18C20.2091 22 22 20.2091 22 18V7C22 4.79086 20.2091 3 18 3H17.75C17.75 2.58579 17.4142 2.25 17 2.25C16.5858 2.25 16.25 2.58579 16.25 3H7.75ZM16.25 6V4.5H7.75V6C7.75 6.41421 7.41421 6.75 7 6.75C6.58579 6.75 6.25 6.41421 6.25 6V4.5H6C4.61929 4.5 3.5 5.61929 3.5 7V18C3.5 19.3807 4.61929 20.5 6 20.5H18C19.3807 20.5 20.5 19.3807 20.5 18V7C20.5 5.61929 19.3807 4.5 18 4.5H17.75V6C17.75 6.41421 17.4142 6.75 17 6.75C16.5858 6.75 16.25 6.41421 16.25 6Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.6a4855854c6bdd53de75c5ec151bc263.svg";
export { ForwardRef as ReactComponent };